import React, { Component } from "react";
import {
  DKLabel,
  DKButton,
  DKIcons,
  showAlert,
  DKIcon,
  DKListPicker,
  INPUT_VIEW_DIRECTION,
  showToast,
  TOAST_TYPE,
  DKListPicker2,
  DKInput
} from "deskera-ui-library";
import {
  COLUMN_CODE,
  TableManger,
  TABLES,
} from "../../../managers/TableManger";
// import { PipelineManager } from "../../../managers/PipelineManager";
import {
  AUTOMATION_ACTIONS,
  AUTOMATION_ELEMENT,
  AUTOMATION_TRIGGERS,
  OPERATOR_LIST,
  SPLIT_ACTION_TYPE,
  SPLIT_CONSTANT,
} from "../AutomationConstants";
import ControlledInput from "../../common/ControlledInput";
import { isEqual } from "lodash";
import { PipelineManager } from "../../../managers/PipelineManager";
import { DateUtil, DATE_FORMATS } from "../../../utility/Date";
import { INPUT_TYPE } from "../../../constants/Constant";
import { FILTER_OPERATORS } from "../../../constants/Enums";
import Utility from "../../../utility/Utility";



const getFieldData = (key: string, value: any, opr = OPERATOR_LIST.EQUAL.token) => ({
    key,
    value,
    opr
  });

export class FieldRow2 extends Component<any, any> {
    constructor(props) {
      super(props);
      this.state = {
        showColumns: false,
        showOptions: false,
        needConditionPicker: false,
        operator: this.props.operator,
      };
    }
    componentDidMount() {
      this.checkAndUpdateDateField();
    }
    componentDidUpdate(prevProps, prevState) {
      if (!isEqual(this.props, prevProps)) {
        this.setState({ operator: this.props.operator });
  
        this.checkAndUpdateDateField();
      }
    }
    hideUnHideColumns = (flag = null) => {
      if (flag === null) flag = !this.state.showColumns;
      this.setState({ showColumns: flag });
    };
    hideUnHideOptions = (flag = null) => {
      if (flag === null) flag = !this.state.showOptions;
      this.setState({ showOptions: flag });
    };
    checkAndUpdateDateField() {
      /* auto selecting today's date for date type field if value is not set */
      const isDateField = ['Date', INPUT_TYPE.DATE].includes(this.props.columns[this.props.field.key]?.type);
      if (isDateField && Utility.isEmptyObject(this.props.field.value?.toString())) {
        this.onDateChange(new Date());
      }
    }
    onDateChange(value: Date) {
      let newDate = DateUtil.getDateStrFromDate(value,DATE_FORMATS['DD-MM-YYYY']);
      this.props.onChange({ ...this.props.field, value: newDate }, null);
    }
  
    render() {
      const allowFieldSelector = !this.props.restrictedFields?.includes(this.props.field.key) && this.props.allowDelete && this.props.type !== AUTOMATION_ACTIONS.CREATE_FACEBOOK_LEAD_ENTITY;
      return (
        <div className="row justify-content-between mt-m ">
          <div
            className={`bg-gray1 row p-h-m fs-m border-radius-m border-m mr-r ${allowFieldSelector ? "cursor-hand" : ""} position-relative justify-content-between`}
            style={{ height: 37 }}
          >
            <div
              className="parent-width parent-height position-absolute"
              style={{ top: 0, left: 0 }}
              onClick={() => {
                if (!allowFieldSelector) return;
                this.props.type !== AUTOMATION_ACTIONS.CREATE_FACEBOOK_LEAD_ENTITY ? this.hideUnHideColumns() : this.hideUnHideColumns(false)
                }
              }
            />
            <DKLabel
              text={this.props.columns[this.props.field.key]?.name}
              className=""
            />
            {allowFieldSelector && (<DKIcon src={DKIcons.ic_arrow_down2} className="ic-s ml-s" />)}
            {this.state.showColumns && (
              <DKListPicker
                className="position-absolute shadow-m border-m z-index-1 parent-width"
                data={Object.keys(this.props.columns).map(
                  (column) => this.props.columns[column].name
                )}
                onClose={() => {
                  this.hideUnHideColumns(false);
                }}
                onSelect={(index, value) => {
                  this.onColumnChange(index);
                  this.hideUnHideColumns();
                }}
              />
            )}
          </div>
          {this.getConditionSelection()}
          {
          (['Date', INPUT_TYPE.DATE].includes(this.props.columns[this.props.field.key]?.type)) ?(
            <div
              className="bg-gray1 row fs-m border-radius-m border-m ml-r cursor-hand position-relative justify-content-between parent-width"
            >
            <DKInput
             className={''}
             value ={DateUtil.getDateFromStr(
                        (this.props.field.value !== ""? this.props.field.value : DateUtil.formatDate(
                        new Date(),DATE_FORMATS["DD-MM-YYYY"] )),
                        DATE_FORMATS['DD-MM-YYYY']
                      )}
             type={INPUT_TYPE.DATE}
             onChange={(value:any) => this.onDateChange(value)}
             direction={INPUT_VIEW_DIRECTION.VERTICAL}
             required={false}
           />
           </div>):
            (![INPUT_TYPE.SELECT, "Select", INPUT_TYPE.MULTI_SELECT, "ref"].includes(this.props.columns[this.props.field.key]?.type)) ? (
            <div
              className="bg-gray1 row fs-m border-radius-m border-m ml-r cursor-hand position-relative justify-content-between parent-width"
              style={{ overflow: "hidden" }}
            >
              <ControlledInput
                className="bg-white"
                direction={INPUT_VIEW_DIRECTION.VERTICAL}
                autoFocus={false}
                value={this.props.field.value}
                placeHolder={"Enter value"}
                readOnly={this.props.readOnly}
                onChange={(e) => this.onOptionChange(-1, e.target.value)}
              />
            </div>
          ) : (
            <div
              className="bg-gray1 row fs-m border-radius-m border-m ml-r cursor-hand position-relative justify-content-between"
              style={{ height: 37 }}
            >
              <div
                className=" parent-width parent-height position-absolute"
                style={{ top: 0, left: 0 }}
                onClick={() => this.hideUnHideOptions()}
              />
              <DKLabel
                text={
                  this.props.columns[this.props.field.key].options.find(
                    (option) => option.id === this.props.field.value
                  )?.name
                }
                style={{  maxWidth: 130, whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden" }}
                className="pl-s"
              />
              <DKIcon src={DKIcons.ic_arrow_down2} className="ic-s ml-s pr-s" />
              {this.state.showOptions && (
                <div className="position-absolute shadow-m border-m z-index-1 parent-width">
                  <DKListPicker2
                    className=""
                    height={200}
                    data={this.props.columns[this.props.field.key].options}
                    onClose={() => {
                      this.hideUnHideOptions(false);
                    }}
                    allowSearch={true}
                    searchableKey="name"
                    displayKey="name"
                    onSelect={(index, value) => {
                      this.onOptionChange(index);
                      this.hideUnHideOptions();
                    }}
                  />
                </div>
              )}
            </div>
          )}
          {this.props.totalFields > 0 && this.props.type !== AUTOMATION_ACTIONS.CREATE_FACEBOOK_LEAD_ENTITY && (
            <DKButton
              icon={DKIcons.ic_delete}
              style={{
                paddingRight: 0,
                visibility: this.props.allowDelete ? 'visible' : 'hidden',
              }}
              onClick={() => this.props.onFieldRemove()}
            />
          )}
        </div>
      );
    }
    onOptionChange(index, value = "") {
      let newOption =
        index !== -1
          ? this.props.columns[this.props.field.key].options[index].id
          : value;
      this.props.onChange(getFieldData(this.props.field.key, newOption, this.props.field.opr), null);
    }
    onColumnChange(index) {
      let newColumn = Object.keys(this.props.columns)[index];
      const column = this.props.columns[newColumn];
      if (newColumn === this.props.field.key) return;
      this.props.onChange(getFieldData(newColumn, TableManger.isSelectField(column) ? column.options[0].id : ""), this.props.field.key);
    }
  
    ////////////////////////////////////////////////////////////////////////////////////
    ////////////////////////////////////////////////////////////////////////////////////
    ////////////////////////////////////////////////////////////////////////////////////
    getOperatorList() {
      const columnType = this.props.columns[this.props.field.key].type;
      const { EQUAL, CONTAINS, GREATER, LESSER, GREATER_EQUAL } = OPERATOR_LIST;
      switch (columnType) {
        case INPUT_TYPE.NUMBER:
          return [EQUAL, GREATER, LESSER].map((operator) => operator.displayName);
        case INPUT_TYPE.DATE:
          return [EQUAL, GREATER_EQUAL].map((operator) => operator.displayName);
        default:
          return [EQUAL, CONTAINS].map((operator) => operator.displayName);
      }
    }
  
    getOperatorSymbol(token) {
      const filteredOperatorKey = Object.keys(OPERATOR_LIST).find(
        (operatorKey) => OPERATOR_LIST[operatorKey].token === token
      );
      const filteredOperator = OPERATOR_LIST[filteredOperatorKey];
      return filteredOperator?.symbol || OPERATOR_LIST.EQUAL.symbol;
    }
  
    getOperatorToken(operatorText) {
      const filteredOperatorKey = Object.keys(OPERATOR_LIST).find(
        (operatorKey) => OPERATOR_LIST[operatorKey].displayName === operatorText
      );
      const filteredOperator = OPERATOR_LIST[filteredOperatorKey];
      return filteredOperator?.token || OPERATOR_LIST.EQUAL.token;
    }
  
    getConditionSelection() {
      const allowConditionSelection = (
        this.props.elementType === AUTOMATION_ELEMENT.TRIGGER && this.props.type !== AUTOMATION_TRIGGERS.DATE_ALERT 
        && this.props.type != AUTOMATION_TRIGGERS.PEOPLE_DATE_ALERT
      ) || this.props.type === AUTOMATION_ACTIONS.SPLIT_WORKFLOW  || this.props.type === AUTOMATION_ACTIONS.CRM_APPROVAL;
      
      return (
        <div className={(allowConditionSelection ? "cursor-hand " : "") + " position-relative"}>
          <div
            onClick={() => allowConditionSelection ? this.setVisibilityOfConditionPicker(true) : null}
          >
            <DKLabel text={this.getOperatorSymbol(this.state.operator || OPERATOR_LIST.EQUAL.token)} />
          </div>
          {this.state.needConditionPicker && (
            <DKListPicker
              className="position-absolute border-m shadow-s-2 border-radius-s z-index-2"
              style={{ top: 10, left: 10 }}
              data={this.getOperatorList()}
              onSelect={(index, displayName) => {
                this.setVisibilityOfConditionPicker(false);
                let opr = this.getOperatorToken(displayName);
                this.props.onConditionChange(opr);
              }}
              width={120}
              onClose={() => this.setVisibilityOfConditionPicker(false)}
            />
          )}
        </div>
      );
    }
    setVisibilityOfConditionPicker = (visible) => {
      this.setState({ needConditionPicker: visible });
    };
  
    ////////////////////////////////////////////////////////////////////////////////////
    ////////////////////////////////////////////////////////////////////////////////////
    ////////////////////////////////////////////////////////////////////////////////////
  }